<template>
    <div class="main-panel">

        <h2 v-if="user" class="header">Manage Customer - UserId: {{ user.userId }}</h2>
  
        <section class="manage-users-section">
            <div class="tabs">

                <div v-for="(tab, index) in tabs"
                     :key="index"
                     class="tab"
                     :class="{ active: activeTab === tab.name }"
                     @click="activeTab = tab.name">
                    {{ tab.label }}
                </div>
            </div>

            <component :is="activeComponent"></component>


        </section>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref, computed, onBeforeMount } from "vue";
    import UserDetails from "../components/UserDetails.vue";
    import { useRoute } from "vue-router";
    import UserOrders from "../components/UserOrders.vue";
    import CreditFreeFreeEntries from "../components/Credit-FreeEntries.vue";
    import ResetPassword from "../components/ResetPassword.vue";
    import PostalEntry from "../components/PostalEntry.vue";
    import UserDetailsResponse from "../responses/UserDetailsResponse";
    import UserService from '../services/user-service';

    export default defineComponent({
        components: {
            UserDetails,
        
            UserOrders,
            CreditFreeFreeEntries,
            ResetPassword,
            PostalEntry,
          
        },
        setup() {
            const tabs = [
                { name: "UserDetails", label: "Details", component: UserDetails },
                { name: "UserOrders", label: "Orders", component: UserOrders },
                { name: "Postal Entry", label: "Postal Entry", component: PostalEntry },
                { name: "CreditFreeFreeEntries", label: "Credit/Free Entries", component: CreditFreeFreeEntries },
            ];
            const route = useRoute();
            const userId = route.params.userId;
            const user = ref<UserDetailsResponse | null>(null);

            const activeTab = ref(tabs[0].name);

            const activeComponent = computed(() => {
                return tabs.find(tab => tab.name === activeTab.value)?.component || UserDetails;
            });

            onBeforeMount(async () => {
                user.value = await UserService.getUserByUserId(Number(userId));
            });

            return {
                userId,
                user, tabs, activeTab, activeComponent };
        },
    });
</script>

<style scoped>
    .manage-users-section {
        display: grid;
        margin-inline: 1rem;
        gap:2rem;
    }
    .header {
        padding: 3rem 0 0 3rem;
    }

    h2 {
        font-size: 1.8em;
        color: #726e6e;
        margin-bottom: 20px;
    }

    .tabs {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 1rem;
        padding-inline: 2rem;
      
    }

    .tab {
        border: 2px solid gray;
        width: 100%;
        padding-inline: 2rem;
        padding-block: 1rem;
        text-align: center;
        cursor: pointer;
        border-radius: 3px;
    }

        .tab.active {
            background-color: var(--clr-primary);
            border: none;
            color: white;
            box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
        }


</style>
